/**
 * Form States
 */
export enum FormStatesEnum {
  None,            // 0
  Draft,           // 1
  PendingApproval, // 2
  Rejected,        // 3
  Approved,        // 4
  Published        // 5
}